import * as Sentry from '@sentry/react';

/**
 * Inicialización de Sentry en el cliente (errores del frontend + logs).
 *
 * Se importa PRIMERO en src/index.js para capturar cualquier error desde el
 * arranque. El DSN es una clave de ingesta publicable (no es un secreto): puede
 * ir embebida en el bundle. Se puede sobreescribir con VITE_SENTRY_DSN.
 *
 * Activación: solo en builds (import.meta.env.PROD === true → production,
 * preproduction, aws). En el dev server local queda inactivo para no ensuciar la
 * cuota. El tag `environment` distingue cada modo en el dashboard.
 */
const DEFAULT_DSN =
  'https://b9e793716e9f0a8383cba0f226028b2f@o4511640640880640.ingest.us.sentry.io/4511640678367232';

const dsn = import.meta.env.VITE_SENTRY_DSN || DEFAULT_DSN;
const environment = import.meta.env.MODE || 'development';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn,
    environment,
    release: import.meta.env.VITE_VERSION,
    integrations: [
      Sentry.browserTracingIntegration(),
      // console.error/console.warn → Sentry Logs.
      Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    ],
    // Trazas de performance acotadas para no quemar la cuota free.
    tracesSampleRate: 0.1,
    // Logs estructurados (la "foto completa" del lado cliente).
    enableLogs: true,
    // Solo monitoreamos requests a nuestra propia API para el tracing distribuido.
    tracePropagationTargets: [/^https:\/\/api\.stiltech\.cl/, /\/api\//],
  });
}

export default Sentry;
